import React, {FunctionComponent} from 'react'
import {useTranslation} from "react-i18next";



export const FeedbackHint: FunctionComponent = () => {

    const {t} = useTranslation()


    return (
        <div className={'feedBackContainer'}>
            <div className="footerBlockHeadline font-serif text-2xl mb-4">{t('benefits.feedbackTitle')}</div>
            <div className="mb-4">{t('benefits.feedbackText')}</div>
            <div className="mb-4"><a href={'mailto:werkstattmeister@repareo.de?subject=Ich%20habe%20Feedback&body=Bitte%20beschreiben%20Sie%20Ihr%20Feedback%20oder%20Problem%20hier%20so%20genau%20wie%20möglich,%20damit%20unser%20Team%20Ihnen%20schnell%20helfen%20kann'}>Feedback abgeben</a></div>
        </div>
    )

}
